"use strict";

define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,
    triggers: {
      click: 'action',
      submit: 'action',
      change: 'action',
      keyup: 'action'
    },
    onAction: function onAction() {
      app.events.commands.execute('modal:login:show');
    }
  });
});